import React from 'react';
import { View } from 'react-native';
import { useUIStore } from '@/store/ui';
import { MAC_FONT_SCALES, normalizeMacFontScale } from '@/constants/macFontScale';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';
import SettingsSection from '@/components/SettingsSection';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import DropdownMenuCheckboxItem from '@/components/DropdownMenu/DropdownMenuCheckboxItem';

export default function MacFontSizeSettings() {
  const { t } = useTranslation();
  const scale = useUIStore(state => normalizeMacFontScale(state.macFontScale));
  const setScale = useUIStore(state => state.setMacFontScale);
  const label = value => value === 1
    ? `100% (${t('settings.appearance.fontSize.default')})`
    : `${Math.round(value * 100)}%`;

  return <SettingsSection title={t('settings.appearance.fontSize.title')}
    subtitle={t('settings.appearance.fontSize.subtitle')} isColumn>
    <View style={{ alignSelf: 'flex-start' }}>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <Button text={label(scale)} accessibilityLabel={t('settings.appearance.fontSize.title')}
            variant="secondary" size="small" appendIcon="chevron-down" appendIconSize={12} />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content style={{ minWidth: 180 }}>
          {MAC_FONT_SCALES.map(value => <DropdownMenuCheckboxItem key={value}
            label={label(value)} isActive={scale === value} onValueChange={() => setScale(value)} />)}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </View>
    <Text size="m" style={{ lineHeight: 23, marginTop: 12 }}>
      {t('settings.appearance.fontSize.preview')}
    </Text>
  </SettingsSection>;
}
